import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { BettingSelectionSuspensionsEditorResponse } from "@/types/ApiResponses/BettingSelection";

export interface GetBettingSelectionsSuspensionsParams {
  lang?: string;
  targetUsername?: string;
  bettingMarketId?: number;
}

export const getBettingSelectionsSuspensions = async (
  props: QueryProps<GetBettingSelectionsSuspensionsParams>
): Promise<BettingSelectionSuspensionsEditorResponse> => {
  const res = await api.client.get(`/betting-selections-new/suspensions`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
